import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CloseIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.closeIcon}`}
        data-testid={testId}
        fill='none'
        height='12'
        viewBox='0 0 12 12'
        width='12'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M4.26678 6.00993L0.402836 2.14599L1.90049 0.64834L5.76443 4.51228L9.63836 0.638356L11.136 2.13601L7.26208 6.00993L11.126 9.87388L9.62837 11.3715L5.76443 7.50759L1.91047 11.3615L0.412821 9.86389L4.26678 6.00993Z'
            fill='currentColor'
        />
    </svg>
);

export default CloseIcon;
